export const CoatingSystemImageHeight: number = 39;
